import CustomSelect from "app/components/atoms/customSelect";

export const getTopicsListUiSchema = {
    "ui:title": "",
    ctpt_topicsid: {
        "ui:widget": props => {
            return <CustomSelect getProps={props} />;
        }
    },
};

